import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversiteLaval = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="Université Laval"
      universityShortName="Laval"
      slug="universite-laval"
      seoTitle="Université Laval Study Rooms | Quebec City Campus Study Guide"
      seoDescription="Complete guide to study rooms at Université Laval. Find Bonenfant Library, group rooms, and silent study spaces. Plus free 24/7 online alternative."
      seoKeywords="universite laval study rooms, laval library, bonenfant library, quebec city university study spaces, ulaval etude"
      canonicalUrl="/study-room/universite-laval/"
      heroDescription="A comprehensive guide to study rooms at Université Laval in Quebec City, including library pavilions and online-course rooms."
      libraryWebsiteUrl="https://www.bibl.ulaval.ca/"
      libraryWebsiteName="Laval Library"
      studySpaces={[
        {
          name: "Jean-Charles-Bonenfant & Alexandre-Vachon Pavilions - Group Rooms",
          features: "Group study rooms seating up to eight people with laptop connections and HD screens. Reservable online up to a week in advance for maximum three hours.",
          feedback: "Modern equipment appreciated; rooms fill quickly during midterms."
        },
        {
          name: "Individual Rooms for Online Classes (Bonenfant)",
          features: "Rooms with network ports for online courses; reservable up to 90 days ahead for maximum three hours.",
          feedback: "Great for Zoom classes; provides network stability and privacy."
        },
        {
          name: "Silent Study Room (Local 5162)",
          features: "Open and closed areas for individual quiet work on the 5th floor.",
          feedback: "Good for drop-in quiet study without reservation."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            When booking at Laval, plan your arrival carefully—<strong>late confirmations void your reservation</strong>. Arrival must be confirmed within the first 15 minutes.
          </p>
          <p className="mb-4">
            For maximum flexibility, try the <strong>5th-floor silent room</strong> for drop-in quiet study. If you need to attend a Zoom class, the <strong>individual online-course rooms</strong> provide network stability and privacy.
          </p>
          <p>
            Students appreciate the modern equipment but note that group rooms fill quickly during midterms.
          </p>
        </>
      }
      summaryTips={[
        "Confirm within 15 minutes: Late arrivals void your reservation.",
        "Use individual online-course rooms: Perfect for Zoom classes with stable network.",
        "Try the 5th-floor silent room: Drop-in quiet study without booking.",
        "Book group rooms early: Fill quickly, especially during midterms.",
        "Use CSW for flexibility: No 15-minute confirmation rules in virtual study rooms."
      ]}
    />
  );
};

export default UniversiteLaval;
